<ngx-spinner></ngx-spinner>
<app-header></app-header>
<div class="wrapper">
  <div class="container">
    <div *ngIf="songContent">
      <div class="partner-profile-detail player-detail">
        <div class="partner-profile">
          <div class="ratio-slider ratio-1-1">
            <img src="{{ songContent?.thumbnails | thumbnails: 'square' }}" />
          </div>
        </div>
        <div class="user-detail">
          <h3 class="mb-2">
            {{ songContent.name }}
          </h3>
          <p class="mb-2 text-secondary">
            <span>{{ songContent.duration | second_time }}</span>
            <span> {{ songContent?.published_year }} </span>
          </p>
          <p *ngIf="songContent?.cast_and_crew?.length > 0">
            <a
              class="text-secondary"
              *ngFor="let cast of songContent?.cast_and_crew; let i = index"
            >
              <span>{{ cast.name | titlecase }}</span>
              <span *ngIf="songContent?.cast_and_crew?.length !== i + 1"
                >,&nbsp;</span
              ></a
            >
          </p>
          <p class="music-description">{{ songContent.description }}</p>

          <button
            *ngIf="!service.audioStatus"
            type="button"
            class="btn btn-theme play-btn mt-2"
            (click)="play()"
          >
            <span class="mdi mdi-play mr-2"></span>
            {{ "MUSIC_INFO.PLAY" | translate }}
          </button>
          <button
            *ngIf="service.audioStatus"
            type="button"
            class="btn btn-theme play-btn mt-2"
            (click)="play()"
          >
            <span class="mdi mdi-pause mr-2"></span>
            {{ "MUSIC_INFO.PAUSE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <section
    class="mb-4 populer-slider pt-4"
    *ngIf="!shimmerStatus.topSongs && songData.length > 0"
  >
    <div class="container">
      <div class="section-head">
        <a href="javascript:void(0)">
          <h2>{{ "MUSIC_INFO.TOP_SONGS" | translate }}</h2>
        </a>
      </div>
      <div class="row top-row">
        <div *ngFor="let data of songData" class="cus-col col-xl-2 mb-4">
          <div
            class="song-item"
            [routerLink]="['/song-detail', data?.public_id]"
          >
            <div class="item-img">
              <div class="ratio-slider ratio-1-1">
                <img src="{{ data?.thumbnails | thumbnails: 'square' }}" />
              </div>
            </div>
            <div class="slider-titles">
              <p class="sub-title" *ngIf="data?.cast_and_crew?.length > 0">
                <a
                  class="orange-link"
                  *ngFor="let cast of data?.cast_and_crew; let i = index"
                >
                  <span>{{ cast.name | titlecase }}</span>
                  <span *ngIf="data?.cast_and_crew?.length !== i + 1"
                    >,&nbsp;</span
                  ></a
                >
              </p>
              <h5 class="title">
                <a title="{{ data.name }}" href="javascript:void(0)">
                  {{ data.name }}
                </a>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="audio-player" *ngIf="playerStatus && songContent">
    <div class="c-player__current" [ngClass]="{ active: isActive }">
      <figure
        class="d-flex align-items-center justify-content-between w-100 mb-0"
      >
        <div class="o-flag__img">
          <a
            class="ratio-slider ratio-1-1"
            screen_name="player_screen"
            event_item="[object Object]"
            title="Agar Tum Saath Ho"
            href="javascript:void(0)"
          >
            <img [src]="getImage()" alt="test" />
          </a>
        </div>
        <figcaption class="o-flag__body">
          <h5 class="">
            <a class="u-color-js-gray" href="javascript:void(0)"
              >{{ songContent?.name }}
            </a>
          </h5>
          <p class="mb-0">
            <a *ngFor="let cast of songContent.cast_and_crew; let i = index">
              <span>{{ cast.name | titlecase }}</span>
              <span *ngIf="songContent.cast_and_crew.length !== i + 1"
                >,&nbsp;</span
              >
            </a>
          </p>
        </figcaption>
        <div class="d-flex align-items-center">
          <div *ngIf="!isLogin" class="favirate-icon">
            <a
              [matMenuTriggerFor]="Add_to_favorites"
              class="like-icon text-white"
            >
              <span
                *ngIf="!songContent.is_favorite.id"
                class="mdi mdi-heart-outline"
              ></span>
              <span
                *ngIf="songContent.is_favorite.id"
                class="mdi mdi-heart fill-back"
              ></span>
            </a>
            <mat-menu #Add_to_favorites="matMenu" class="please_login">
              <div (click)="$event.stopPropagation()">
                <p>{{ "MUSIC_INFO.SIGNIN_MESSAGE" | translate }}</p>
                <hr />
                <a
                  href="javascript:void(0)"
                  (click)="singIn('Add_to_favorites')"
                >
                  {{ "VIDEO_DETAIL.SIGN_IN" | translate }}
                </a>
              </div>
            </mat-menu>
          </div>
          <div *ngIf="isLogin" class="favirate-icon">
            <a
              class="like-icon text-white text-center"
              (click)="favoriteSong(songContent)"
            >
              <span
                *ngIf="!songContent.is_favorite.id"
                class="mdi mdi-heart-outline"
              ></span>
              <span
                *ngIf="songContent.is_favorite.id"
                class="mdi mdi-heart fill-back"
              ></span>
            </a>
          </div>

          <a class="like-icon text-white text-center" (click)="classActive()">
            <span
              class="mdi"
              [ngClass]="{
                'mdi-dots-horizontal': !isActive,
                'mdi-chevron-down': isActive
              }"
            ></span>
          </a>
        </div>
      </figure>
      <div class="player-popup">
        <div *ngIf="!isLogin">
          <a
            [matMenuTriggerFor]="Add_to_playlist"
            href="javascript:void(0)"
            class="addtoplaylist"
          >
            <span class="icon-watch-list"></span>
            {{ "MUSIC_INFO.ADD_TO_PLAYLIST" | translate }}
          </a>
          <mat-menu #Add_to_playlist="matMenu" class="please_login">
            <div (click)="$event.stopPropagation()">
              <p>{{ "MUSIC_INFO.SIGNIN_MESSAGE" | translate }}</p>
              <hr />
              <a href="javascript:void(0)" (click)="singIn('Add_to_playlist')">
                {{ "VIDEO_DETAIL.SIGN_IN" | translate }}
              </a>
            </div>
          </mat-menu>
        </div>
        <div *ngIf="isLogin">
          <a
            href="javascript:void(0)"
            class="addtoplaylist"
            (click)="addToPlayList(songContent)"
          >
            <span class="icon-watch-list"></span>
            {{ "MUSIC_INFO.ADD_TO_PLAYLIST" | translate }}
          </a>
        </div>

        <a href="javascript:void(0)" class="share" (click)="openShareContent()">
          <span class="mdi mdi-share-variant-outline"></span>
          {{ "MUSIC_INFO.SHARE" | translate }}
        </a>
      </div>
    </div>
    <audio-vjs-player
      *ngIf="songContent?.output_url"
      (buttonStatus)="songPlay($event)"
      (playerStatus)="songStatus($event)"
      [playinStatus]="service.audioStatus"
      [options]="{
        autoplay: true,
        bigPlayButton: false,
        loadingSpinner: true,
        errorDisplay: false,
        sources: [
          {
            src: songContent?.output_url,
            type: typeContent
          }
        ],
        controlBar: {
          pictureInPictureToggle: false,
          fullscreenToggle: false
        }
      }"
    >
      <!-- withCredentials: true  -->
    </audio-vjs-player>
  </div>
</div>
